const page_our_story = {

  init: () => {
    if ($('.os-slider')[0]) {
      $('.os-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        vertical: true,
        verticalSwiping: true,
        dots: true,
        responsive: [{
          breakpoint: 769,
          settings: {
            vertical: false,
            verticalSwiping: false,
          }
        }]
      });
    }
  }

};
export default page_our_story;
